export const isAdmin = (user) => {
  if (!user) return false;
  
  // Check if user has ADMIN role
  if (user.role === 'ADMIN') return true;
  
  // Check if user is in ADMIN group
  if (user.groups && Array.isArray(user.groups) && user.groups.includes('ADMIN')) return true;
  
  return false;
};

export const isModerator = (user) => {
  if (!user) return false;
  
  // Check if user has MODERATOR role
  if (user.role === 'MODERATOR') return true;
  
  // Check if user is in MODERATOR group
  if (user.groups && Array.isArray(user.groups) && user.groups.includes('MODERATOR')) return true;
  
  return false;
};

export const hasAdminAccess = (user) => {
  return isAdmin(user) || isModerator(user);
};

export const canManageHypeRating = (user) => {
  // Only full admins can manage HypeRating
  return isAdmin(user);
};

export const getAdminPermissions = (user) => {
  if (!user) return { canModerate: false, canManageContent: false, canManageHypeRating: false };
  
  const admin = isAdmin(user);
  const moderator = isModerator(user);
  
  return {
    canModerate: admin || moderator,
    canManageContent: admin || moderator,
    canManageHypeRating: admin,
    canViewReports: admin || moderator,
    canManageUsers: admin
  };
};